import React, { Component } from 'react';

import {
    Link, Redirect
} from 'react-router-dom';
import {connect} from 'react-redux';
import {login} from '../../actions/Login';
import {Loader} from '../../components/Loader';

class PasswordConfirm extends Component {
    constructor(props){
        super(props);
        this.state = {
            password: "",
            isConfirmed: false,
            passwordErrMsg: ""
        }
    }

    handleEnterPress = e => {
        e.preventDefault();
        if( e.keyCode === 13 ){
            return this.handleConfirm();
        }
    }

    handleConfirm = () => {
		let {password} = this.state;
        let {phone} = this.props;
        
		if (!password) {
            this.setState({
                passwordErrMsg: "Mật khẩu không được để trống"
            })
            return this.password.focus();
        }else if (password.length < 6) {
            this.setState({
                passwordErrMsg: "Vui lòng nhập tối thiểu 6 ký tự"
            })
            return this.password.focus();
        }else if (password.length > 64) {
            this.setState({
                passwordErrMsg: "Vui lòng nhập tối đa 64 ký tự"
            })
            return this.password.focus();
        }
        
		this.props.dispatch(login(phone, password));
    };
    
    setPassword = (e) => {
		this.setState({
			password: e.target.value
		}, () => {
            if(this.state.password){
                this.setState({
                    passwordErrMsg: ""
                })
            }
            else {
                this.setState({
                    passwordErrMsg: "Mật khẩu không được để trống"
                })
            }
        })
    };
    
    componentWillReceiveProps(nextProps) {
        console.log({nextProps});
        console.log('this props ', this.props);
		if (nextProps.logged && nextProps.logged !== this.props.logged)
			return this.setState({
                isConfirmed: true
            })

        if (nextProps.loginErrMsg) return 
    }

    componentDidMount(){
        document.addEventListener('keyup', this.handleEnterPress)
    }

    componentWillUnmount(){
        document.removeEventListener('keyup', this.handleEnterPress)
    }

    render() {
        if(this.state.isConfirmed) return <Redirect to="/setting" />
        let {loginErrMsg, isLogging} = this.props;
        let {passwordErrMsg} = this.state;

        return (
            <React.Fragment>
            <div className="container mt-4 maxW-768">
                <div className="left-icons">
                    <Link to="/information"><img src="/cashier/shop/static/assets/images/icon-back.svg" width="28" alt=""/></Link>
                </div>
                
                <div className="page-title text-center">Xác nhận thay đổi</div>
                
                <div className="mt-5 text-center">Vui lòng nhập mật khẩu đăng nhập, để xác nhận thay đổi cài đặt</div>

                    {
                        loginErrMsg ? <div className="alert alert-danger fade show mt-4 mb-0 fs- col-sm-6 mr-sm-auto ml-sm-auto" role="alert">{loginErrMsg}</div> : null
                    }

                <div className="row mt-5 justify-content-center">
                    <div className="col-sm-6 mb-2">
                        <form className="needs-validation" onSubmit={e => e.preventDefault()}>
                            <div className="form-group">
                                <label>MẬT KHẨU</label>
                                <input ref={i => this.password = i} type="password" className="form-control" autoComplete="false"
                                    placeholder="Mật khẩu đăng nhập..." onChange={this.setPassword} required/>
                                <div className="invalid-feedback" style={{display: "block", marginTop: "10px"}}>{passwordErrMsg}</div>
                            </div>
                        </form>
                    </div>
                    
                </div>
                
                <div className="row mt-5 justify-content-center">
                    {
                        isLogging ? <Loader/> :
                        <React.Fragment>
                            <div className="col-sm-4 mb-3">
                                <input type="button" className="btn btn-main w-100" value="TIẾP TỤC"
                                    onClick={this.handleConfirm} />
                            </div>
                            <div className="col-sm-4 mb-3">
                                <Link to="/home" className="btn btn-border w-100">BỎ QUA</Link>
                            </div>
                        </React.Fragment>
                    }
                    
                </div>
            </div>
            
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		isLogging: state.loginData.isLogging,
		logged: state.loginData.logged,
        phone: state.loginData.phone,
		loginErrMsg: state.loginData.accountErrMsg,
	}
};
export default connect(mapStateToProps)(PasswordConfirm)